const PromoCodeDurationsEnum = {
  ONCE: 'once',
  FOREVER: 'forever',
  REPEATING: 'repeating',
};

export default PromoCodeDurationsEnum;
